import { useEffect, useState } from 'react';
import { imgUrl } from '@/lib/api';

/**
 * HeroCarousel — auto-rotating slideshow.
 * Props: images (array of URLs) — 3-sec interval
 */
export default function HeroCarousel({ images, interval = 3000, alt = 'Kanbr project' }) {
    const [idx, setIdx] = useState(0);
    const total = images?.length || 0;

    useEffect(() => {
        if (total <= 1) return;
        const t = setInterval(() => setIdx((i) => (i + 1) % total), interval);
        return () => clearInterval(t);
    }, [total, interval]);

    if (total === 0) return null;

    return (
        <div className="relative w-full aspect-[4/3] overflow-hidden bg-slate-100" data-testid="hero-carousel">
            {images.map((src, i) => (
                <img
                    key={i}
                    src={imgUrl(src)}
                    alt={`${alt} ${i + 1}`}
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${i === idx ? 'opacity-100' : 'opacity-0'}`}
                    loading={i === 0 ? 'eager' : 'lazy'}
                />
            ))}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10" data-testid="carousel-dots">
                {images.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setIdx(i)}
                        aria-label={`Slide ${i + 1}`}
                        data-testid={`carousel-dot-${i}`}
                        className={`w-2 h-2 rounded-full transition-all ${i === idx ? 'bg-white w-6' : 'bg-white/60'}`}
                    />
                ))}
            </div>
        </div>
    );
}

export const CAROUSEL_IMAGES = [
    '/api/static/site/carousel/1.jpg',
    '/api/static/site/carousel/2.jpg',
    '/api/static/site/carousel/3.jpg',
    '/api/static/site/carousel/4.jpg',
    '/api/static/site/carousel/5.jpg',
];
